import { isObject } from "@atlassiansox/bxp-shared-utils";

import { CSSUnits, isCSSUnits } from "./css-units";

export type SizeType = "keyword" | "units";

export function isSizeType(value: string): value is SizeType {
    return ["keyword", "units"].includes(value);
}

export type SizeKeyword = "auto" | "cover" | "contain" | "initial" | "inherit";

export function isSizeKeyword(value: string): value is SizeKeyword {
    return ["auto", "cover", "contain", "initial", "inherit"].includes(value);
}

export type Size = {
    fieldType: SizeType;
    keyword: SizeKeyword;
    units: {
        unit: CSSUnits;
        width: number;
        height: number;
        isAutoWidth: boolean;
        isAutoHeight: boolean;
    };
};

export function isSize(value: unknown): value is Size {
    if (!isObject(value)) {
        return false;
    }
    const temp = value as Size;

    return (
        isSizeType(temp.fieldType) &&
        isSizeKeyword(temp.keyword) &&
        isObject(temp.units) &&
        isCSSUnits(temp.units.unit) &&
        typeof temp.units.width === "number" &&
        typeof temp.units.height === "number" &&
        typeof temp.units.isAutoWidth === "boolean" &&
        typeof temp.units.isAutoHeight === "boolean"
    );
}
